// آدرس‌های عمومیِ یه سیگنال.
//
// توکنِ عمومی همیشه از قبل توی `signals.share_token` هست — با ساخته شدنِ سیگنال
// درست می‌شه، نه با اولین اشتراک. پس ساختِ لینک هیچ رفت‌وبرگشتی با سرور نداره و
// همون لحظه آماده‌ست. اگه لینک موقعِ اشتراک ساخته می‌شد، هر بار یه مکث و یه
// احتمالِ شکست داشتیم — درست همون‌جایی که کاربر عجله داره.
//
// از فاز ۴ در core است: سایت هم همین لینک رو نشون می‌ده و دامنه نباید دو جا
// نوشته بشه. **باز کردنِ** شیتِ اشتراک هرکدوم مالِ خودشونه (موبایل: Share
// از react-native، وب: navigator.share یا کپی در کلیپ‌بورد).
//
// ⚠️ تا مایگریشن 0066 این‌جا `goout.app` نوشته شده بود — دامنه‌ای که مالِ ما
// نیست و هیچ‌وقت هم چیزی سرو نکرده. یعنی هر لینکی که با پیامک یا شیتِ اشتراک
// فرستاده شده بود، توی مرورگرِ طرف مقابل مُرده بود. سایتِ واقعی outami.com است.
export const SITE = 'https://outami.com';

/**
 * پایه‌ی لینک‌های /s/ و /i/ — جدا از SITE، چون SITE جاهای دیگری هم مصرف
 * دارد که همیشه پروداکشن است (GET_APP_URL).
 *
 * چرا قابل‌تنظیم (WHOSUP-117): لینکی که روی استیجینگ ساخته می‌شود باید به
 * همان استیجینگ اشاره کند — سیگنالش در دیتابیس develop است و outami.com
 * (پروداکشن) توکنش را ندارد؛ نتیجه‌اش «لینک منقضی شده» برای لینکی بود که
 * همین الان ساخته شده بود. همان الگوی setAuthLinkBase در authLink.ts:
 * وب موقع بوت origin خودش را می‌گذارد (پروداکشن → همان outami.com)، اپِ
 * WhosUp Dev هم EXPO_PUBLIC_AUTH_HOST را — بیلد پروداکشن آن متغیر را
 * ندارد و پیش‌فرض می‌ماند.
 */
let linkBase = SITE;

/** فقط برای محیط‌های غیرپروداکشن؛ با آرگومانِ خالی به پیش‌فرض برمی‌گردد. */
export function setShareLinkBase(base?: string | null): void {
  linkBase = (base || SITE).replace(/\/+$/, '');
}

/** لینکِ عمومیِ سیگنال — یکی برای همه. صفحه‌اش فقط‌خواندنی است (مایگریشن 0067). */
export const signalUrl = (token: string): string => `${linkBase}/s/${token}`;

/**
 * لینکِ دعوتِ **شخصی** (مایگریشن 0066).
 *
 * فرقش با بالایی: صفحه از قبل می‌دونه کی پشتشه، پس اسم نمی‌پرسه و جواب به
 * همون ردیفِ گیرنده می‌شینه. توکنش هم ۱۴۴ بیته و نه ۷۲ بیت، چون این یکی
 * هیچ‌وقت دستی تایپ نمی‌شه و کوتاه بودنش هیچ سودی نداره.
 */
export const inviteUrl = (token: string): string => `${linkBase}/i/${token}`;
